import React, { useState, useEffect, useRef } from "react";
import { Typewriter } from "react-simple-typewriter";
import Terminal from "./Terminal";

const NAV_SECTIONS = [
  { id: "home", label: "Home" },
  { id: "about", label: "About" },
  { id: "experience", label: "Experience" },
  { id: "resume", label: "Skills" },
  { id: "projects", label: "Projects" },
  { id: "certificate", label: "Achievements" },
  { id: "contact", label: "Contact" },
];

const StyledName = () => (
  <>
    I&apos;<span className="name-highlight">m</span> Vivek Singh.
  </>
);

const Header = ({ data, resumeSkills }) => {
  const [typingDone, setTypingDone] = useState(false);
  const [navOpaque, setNavOpaque] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const activeSectionRef = useRef("home");

  useEffect(() => {
    if (data) {
      const charCount = `I'm ${data.name}.`.length;
      const timeout = setTimeout(() => setTypingDone(true), charCount * 70 + 600);
      return () => clearTimeout(timeout);
    }
  }, [data]);

  useEffect(() => {
    const getTop = (el) => el.getBoundingClientRect().top + window.scrollY;

    const handleScroll = () => {
      const scrollY = window.scrollY;

      setNavOpaque(scrollY > 100);

      let current = "home";
      for (const { id } of NAV_SECTIONS) {
        const el = document.getElementById(id);
        if (el && getTop(el) - 250 <= scrollY) {
          current = id;
        }
      }

      if (current !== activeSectionRef.current) {
        activeSectionRef.current = current;
        setActiveSection(current);
        window.history.replaceState(null, null, `#${current}`);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (data) {
    var name = data.name;
    var occupation = data.occupation;
    var description = data.description;
    var city = data.address.city;
    var networks = data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url} target="_blank" rel="noopener noreferrer">
            <i className={network.className}></i>
          </a>
        </li>
      );
    });
  }

  return (
    <header id="home">
      <nav id="nav-wrap" className={navOpaque ? "opaque" : ""}>
        <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
          Show navigation
        </a>
        <a className="mobile-btn" href="#home" title="Hide navigation">
          Hide navigation
        </a>

        <ul id="nav" className="nav">
          {NAV_SECTIONS.map(({ id, label }) => (
            <li key={id} className={activeSection === id ? "current" : ""}>
              <a className="smoothscroll" href={`#${id}`}>
                {label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="row banner">
        <div className="banner-text">
          <h1 className="responsive-headline">
            {typingDone ? (
              <StyledName />
            ) : name ? (
              <Typewriter
                words={[`I'm ${name}.`]}
                loop={1}
                typeSpeed={70}
                deleteSpeed={50}
              />
            ) : null}
          </h1>
          <h3>
            Based in {city}. <span>{occupation}</span>. {description}.
          </h3>
          <hr />
          <ul className="social">{networks}</ul>
        </div>
      </div>

      <Terminal mainData={data} resumeData={resumeSkills} />

      <p className="scrolldown">
        <a className="smoothscroll" href="#about">
          <i className="icon-down-circle"></i>
        </a>
      </p>
    </header>
  );
};

export default Header;
